import React, { useContext } from "react";
// import CloseIcon from "@mui/icons-material/Close";
import { Dialog, makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { ThemeContext } from "../../theme/ThemeContext";
import CancelButtons from "../DialogBoxComponent/CancelButtons";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {},
}));

export default function BulkEmployeeDialog(props) {
  const classes = useStyles();
  const { darkMode } = useContext(ThemeContext);
  const { onSubmit, children, onClose, ...other } = props;

  const handleClose = () => {
    props.onClose(false);
  };
  return (
    <>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        {...props}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return; // Prevent closing
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle
          variant="h4"
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={handleClose} />
          </IconButton>
          {props.Header}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        {props.children}
        <DialogActions
          style={{
            justifyContent: "flex-end",
            display: "flex",
            flexDirection: "row",

            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <CancelButtons onClick={() => props.cancel()}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.cancelText}
            </Typography>
          </CancelButtons>

          <SubmitButtons onClick={onSubmit} type="submit">
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.acceptText}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
